import React from "react"
import ComplianceTableWithControlsWithData from "../../components/ComplianceTableWithControls/ComplianceTableWithControlsWithData"
import ResourceBannerWithData from "../../components/ResourceBanner/ResourceBannerWithData"
import SecondaryNavWithData from "../../components/SecondaryNav/SecondaryNavWithData"
import PropTypes from "prop-types"

const DetailView = props => {
  return (
    <div className="DetailView content">
      <ResourceBannerWithData />
      {props.secondaryNav ? <SecondaryNavWithData /> : null}
      <ComplianceTableWithControlsWithData />
    </div>
  )
}

DetailView.propTypes = {
  secondaryNav: PropTypes.bool,
}

export default DetailView
